// @ts-check
// Onde o menu lateral está: Configurações incluem as listas e os registros da Estrutura da escola (Unidades, Cursos,
// Períodos letivos), que moram no menu de Configurações. Abrir um deles mantém esse menu, com o item marcado, em vez
// de trocar para o menu principal (docs/arquitetura-appcrm/08-contrato-navegacao-mobile.md, seção 2.1).

/**
 * @typedef {{ section?: string, objectMetadataId?: string | null }} StructureItem
 * @typedef {{ nameSingular: string, namePlural: string }} StructureObject
 */

/**
 * Item da Estrutura da escola que a rota abre: a lista `/objects/<plural>` (com ou sem view) ou o registro
 * `/object/<singular>/<id>`. Nulo fora delas.
 * @template {StructureItem} TItem
 * @param {string} pathname @param {ReadonlyArray<TItem>} items @param {ReadonlyMap<string, StructureObject>} objectsById
 * @returns {TItem | null}
 */
export function schoolStructureItemOf(pathname, items, objectsById) {
  const [, kind, rawName] = pathname.split('/');
  if ((kind !== 'objects' && kind !== 'object') || !rawName) return null;
  let name = rawName;
  try {
    name = decodeURIComponent(rawName);
  } catch {
    return null;
  }
  for (const item of items) {
    if (item.section !== 'SCHOOL_STRUCTURE' || !item.objectMetadataId) continue;
    const object = objectsById.get(item.objectMetadataId);
    if (!object) continue;
    if (kind === 'objects' ? object.namePlural === name : object.nameSingular === name) return item;
  }
  return null;
}

/**
 * O menu lateral mostra Configurações? Nas rotas /settings e nas telas da Estrutura da escola que o membro vê nesse menu.
 * @param {string} pathname @param {ReadonlyArray<StructureItem>} items itens da Estrutura da escola mostrados nas configurações
 * @param {ReadonlyMap<string, StructureObject>} objectsById
 */
export function isSettingsLocation(pathname, items, objectsById) {
  return pathname === '/settings' || pathname.startsWith('/settings/') || schoolStructureItemOf(pathname, items, objectsById) !== null;
}
